/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Analysis_DescriptionInputs */

const en_gc_guides_analysis_description = /** @type {(inputs: Gc_Guides_Analysis_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare a clean source table in GridCraft, compare values with a chart and explore grouped summaries with a PivotTable in the ArtCraft desktop app.`)
};

const zh_gc_guides_analysis_description = /** @type {(inputs: Gc_Guides_Analysis_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 GridCraft 中整理来源表格，用图表比较数值，并在 ArtCraft 桌面应用中通过数据透视表探索分组汇总。`)
};

/**
* | output |
* | --- |
* | "Prepare a clean source table in GridCraft, compare values with a chart and explore grouped summaries with a PivotTable in the ArtCraft desktop app." |
*
* @param {Gc_Guides_Analysis_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_analysis_description = /** @type {((inputs?: Gc_Guides_Analysis_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Analysis_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_analysis_description(inputs)
	return zh_gc_guides_analysis_description(inputs)
});
export { gc_guides_analysis_description as "gc.guides.analysis.description" }